// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as InsuranceDashboard from "./InsuranceDashboard.bs.js";
import * as InsuranceAssetsManager from "../assets/InsuranceAssetsManager.bs.js";

InsuranceAssetsManager.importCss(undefined);

function InsuranceDashboardWrapper(Props) {
  var uuid = Props.uuid;
  var auth_token = Props.auth_token;
  var language = Props.language;
  var category = Props.category;
  var eligibility_status = Props.eligibility_status;
  var geo_region = Props.geo_region;
  return React.createElement("div", undefined, React.createElement(InsuranceDashboard.make, {
                  uuid: uuid,
                  auth_token: auth_token,
                  language: language,
                  category: category,
                  eligibility_status: eligibility_status,
                  geo_region: geo_region
                }));
}

var make = InsuranceDashboardWrapper;

export {
  make ,
  
}
/*  Not a pure module */
